/**
 * UranIA PA — Front end 1: pagina dei servizi (`/servizi`).
 *
 * Atterraggio post-login per funzionario_adg / beneficiario_ri (e per gli
 * admin, che comunque atterrano su /console — vedi `lib/ruoli.ts`). La
 * guardia (autenticazione) non è più qui: vive sul segmento `(servizi)`
 * (`_servizi.tsx`, `guardiaAutenticato()` — Riordino della mappa delle
 * rotte, Rilascio A passo A.1), perché tutte le rotte del segmento
 * ammettono esattamente lo stesso insieme di ruoli che ammetteva
 * `PERMESSI['/servizi']`: nessuna restrizione oltre l'autenticazione.
 *
 * `createRoute` a mano invece di `createFileRoute`: nessun plugin di routing
 * su file installato in questo repo (vedi header di `router.tsx`), stesso
 * adattamento già fatto per `86b8d49`.
 */

import { createRoute } from '@tanstack/react-router';

import { ServiziPage } from '../features/front/ServiziPage.tsx';
import { Route as ServiziSegmentRoute } from './_servizi.tsx';

export const Route = createRoute({
  getParentRoute: () => ServiziSegmentRoute,
  path: '/servizi',
  component: ServiziPage,
});
